"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _wedding = require("@/api/wedding");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Promotion',
  data: function data() {
    return {
      ruleForm: {
        appKey: '',
        pid: '',
        appSecret: ''
      },
      rules: {
        pid: [{
          required: true,
          message: '请输入pid',
          trigger: 'blur'
        }],
        appKey: [{
          required: true,
          message: '请输入AppKey',
          trigger: 'blur'
        }],
        appSecret: [{
          required: true,
          message: '请输入AppSecret',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.queryIt();
  },
  methods: {
    queryIt: function queryIt() {
      var _this = this;
      (0, _wedding.get_pid)({}).then(function (res) {
        _this.ruleForm = (0, _objectSpread2.default)({}, res.data);
      });
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否确认保存此配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            (0, _wedding.save_pid)({
              appKey: _this2.ruleForm.appKey,
              appSecret: _this2.ruleForm.appSecret,
              pid: _this2.ruleForm.pid
            }).then(function (res) {
              if (res.data) {
                _this2.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                _this2.queryIt();
              }
            });
          });
        } else {
          return false;
        }
      });
    }
  }
};